module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/2/5-0f5a3fa09184f4397366b5805c30480b.jpg";